import React, { useContext, useEffect, useRef, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, monthData } from "../../Constants/constants";
import GaugeChart from "react-gauge-chart";

import Select from "react-select"; 
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { useNavigate } from 'react-router-dom';
const AttendanceDashboard = () => {
  const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
  const sourceDivRef = useRef(null); // Ref for the source div
  const [targetDivHeight, setTargetDivHeight] = useState("auto");
  const [monthYear, setMonthYear] = useState("");
  const inputRef = useRef(null);
  const [dailyData, setDailyData] = useState({
    employee_count: "",
    presentee_count: "",
    today_leave_count: 0,
    monthly_leave_count: "",
  });
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [selectedOfferStatus, setSelectedOfferStatus] = useState("0");

  const [errors, setErrors] = useState({});
  const [monthlyAttendanceData, setMonthlyAttendanceData] = useState({
    present_rate: "0.00%",
    absence_rate: "0.00%",
  });

  const [departmentAttendanceData, setDepartmentAttendanceData] = useState([]);
const[gross,setGross] =useState([]);
  // const [attendanceData, setAttendanceData] = useState({
  //   absence_rate: "0.00%",
  //   present_rate: "0.00%",
  // });
  // const [AbsenceData,  setAbsenceData] = useState({});

  // const [PresentData, setPresentData] = useState({ });
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  //  const presentRate = parseFloat(attendanceData.present_rate)

  const [offerLetterStatusCounts, setOfferLetterStatusCounts] = useState({});
  const [offerSentCount, setOfferSentCount] = useState({});
  const currentDateAndTime = () => {
    return new Date().toISOString()?.slice(0, 19).replace("T", " "); // Example: '2024-12-24 15:30:00'
  };

  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0"); // "11"
  const currentYear = currentDate.getFullYear(); // "2024"
  const [genderData, setGenderData] = useState([]);
  const [chartOptionsLeave, setChartOptionsLeave] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    present_rate: "0",
    absence_rate: "0",
  });
  const[ chartOptionsGross, setChartOptionsGross] = useState([]);

  const [leaveData, setLeaveData] = useState([]);

  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [appointmentLetterCount, setappointmentLetterCount] = useState(0);
  const [selectMonthAppointment, setselectMonthAppointment] = useState("");
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [selectMonthJoin, setSelectMonthJoin] = useState([]);

  const [departmentData, setDepartmentData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [chartOptionsfGender, setChartOptionsGender] = useState({});
  const [charAttendenceData, setCharAttendenceData] = useState({});
  const [joiningData, setJoiningData] = useState({});
  const [locationCount, setLocationCount] = useState({});
  const [chartLocationOptions, setChartLocationOptions] = useState({});
  const[chartEarnedOptions,setChartEarnedOptions] = useState();
  const[departmentEarnedData,setDepartmentEarnedData]=useState();
  const[locationEarnedData,setLocationEarnedData]=useState();
  const[chartEarnedLocOptions,setChartEarnedLocOptions]=useState();
  const[departmentNetData,setDepartmentNetData]=useState();
  const[chartNetOptions,setChartNetOptions]=useState();
  const[locationNetData,setLocationNetData]=useState();
  const[chartNetLocOptions,setChartNetLocOptions]=useState();
  const[chartOverTimeOptions,setChartOverTimeOptions]=useState();
  const[departmentOverTimeData,setDepartmentOverTimeData]=useState();
  const[locationOverTimeData,setLocationOverTimeData]=useState();
  const[selectMonthOver,setSelectMonthOver]=useState();
  const[selectMonthLocOver,setSelectMonthLocOver]=useState();
  const[chartLocOverTimeOptions,setChartLocOverTimeOptions]=useState();


  
  // Helper function to get current month and year in "MM-YYYY" format
  const getCurrentMonthYear = () => {
    const date = new Date();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${year}`;
  };
  const [visibleDepartments, setVisibleDepartments] = useState(6); // Start with 6 departments

  

  // Generate options for the chart
  // const chartConfig = {
  //   chart: {
  //     type: 'bar',
  //     height: '30vh',
  //     toolbar: {
  //       show: true, // Show chart toolbar (optional)
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: true, // Horizontal bars
  //     },
  //   },
  //   xaxis: {
  //     categories: chartOptions?.labels?.slice(0, visibleDepartments) || ["No Data"],
  //     labels: {
  //       rotate: -45, // Optional: Rotate labels for better visibility
  //     },
  //     title: {
  //       text: 'Departments', // Title of X-axis
  //     },
  //     range: visibleDepartments, // Set the range of visible departments
  //   },
  //   yaxis: {
  //     title: {
  //       text: 'Employee Count', // Y-axis title
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false, // Disable data labels on the bars
  //   },
  //   grid: {
  //     show: true, // Display grid lines for better readability
  //   },
  //   legend: {
  //     position: 'bottom',
  //   },
  // };

  // Series data for the chart (Employee Count for each department)
  // const seriesData = [
  //   {
  //     name: 'Employee Count',
  //     data: chartOptions?.series?.slice(0, visibleDepartments) || [0],
  //   },
  // ];

  // {
  //   chart: {
  //     type: "area",
  //   },
  //   series: [
  //     {
  //       name: "Average Leave Of Employees",
  //       data: [50, 35, 40, 60, 49, 60, 70, 30],
  //     },
  //   ],
  //   xaxis: {
  //     categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
  //   },
  //   colors: ["#687cfe"],
  // }

  const getList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesCountStatusWise`, {
        params: {
          date: currentDateAndTime(),
          // employee_status: "Active",
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesCountStatusWise =>", data);
        if (response.data.success === true) {
          setDailyData((prevState) => ({
            ...prevState,
            employee_count: data?.data?.active_count,
          }));
        } else {
        }
      });
  };
  // const getDepartmentWiseCountList = () => {
  //   const headers = apiHeaderJSON;

  //   axios
  //     .get(`${apiURL}DashboardRouter/GetEmployeesCountDepartmentWise`, {
  //       params: {
  //         date: currentDateAndTime(),
  //         employee_status: "Active",
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetEmployeesCountDepartmentWise =>", data);
  //       if (response.data.success === true) {
          
  //         let departmentTitles = data?.data?.map(
  //           (dept) => dept.department_title
  //         );
  //         console.log("departmentTitles", departmentTitles);
  //         let employeeCounts = data?.data?.map((dept) => dept.employee_count);
  //         console.log("employeeCounts?.length",employeeCounts?.length);
  //         setDepartmentData(employeeCounts?.length);
  //           const seriseData={
  //               name: 'Department Wise Count',
  //               data: [...employeeCounts],
  //             };
  //           const chunkSize = 5; 
  //           const nestedLabels = [];
  //           for (let i = 0; i < departmentTitles.length; i += chunkSize) {
  //             nestedLabels.push(departmentTitles && departmentTitles?.slice(i, i + chunkSize));
  //           }
  //           const chunks = [];
  //           for (let i = 0; i < seriseData.data.length; i += chunkSize) {
  //             chunks.push(seriseData.data && seriseData.data?.slice(i, i + chunkSize));
  //           }
  //           console.log("nestedLabels",nestedLabels)
  //           departmentTitles=nestedLabels;
  //           // Map the chunks into the desired array format
  //           const transformedSeriseData = chunks.map(chunk => ({
  //             name: seriseData.name,
  //             data: chunk,
  //           }));
  //           employeeCounts=transformedSeriseData;
  //           console.log("employeeCounts",employeeCounts)

  //         // setChartOptions({
  //         //   chart: {
  //         //     type: "donut",
  //         //   },
  //         //   series: [
  //         //     {
  //         //       name: "Department Wise Count",
  //         //       data: [...employeeCounts],
  //         //     },
  //         //   ],
  //         //   xaxis: {
  //         //     categories: [...departmentTitles],
  //         //   },
  //         //   colors: ["#687cfe"],
  //         // });

  //         setChartOptions({
  //           labels: departmentTitles || [],
  //           series: employeeCounts || [],
  //         });
  //       } else {
  //         console.error(
  //           "Failed to fetch GetEmployeesCountDepartmentWise count data:",
  //           data.message || "Unknown error"
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };


  

 

//   const getLeaveTypeWiseCountList = () => {
//     const headers = apiHeaderJSON;

//     axios
//       .get(`${apiURL}DashboardRouter/GetEmployeesOnLeaveTodayByLeaveType`, {
//         params: {
//           employee_status: "active",
//         },
//         headers,
//       })
//       .then((response) => {
//         const data = response.data;
//         console.log("GetEmployeesLeaveType =>", data);

//         if (response.data.success === true) {
//           setLeaveData(data?.data);

//           const leaveTypeName = data?.data?.map(
//             (leave) => leave.leave_type_name
//           );
//           console.log("leaveData", leaveTypeName);
//           const leaveCount = data?.data?.map((leave) => leave.leave_count);
//           console.log("leaveCount", leaveCount);

//           setChartOptionsLeave({
//             labels: leaveTypeName || [],
//             series: leaveCount || [],
//           });
//         } else {
//           console.error("Failed to fetch leave type-wise count data.");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   };

  const getPresentEmployeeList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesTodaysAttendanceCount`, {
        params: {
          date: currentDateAndTime(),
          request_date: currentDateAndTime()?.split(" ")[0],
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesTodaysAttendanceCount =>", data);
        if (response.data.success === true) {
          setDailyData((prevState) => ({
            ...prevState,
            presentee_count: data?.data[0]?.present_employee_count,
          }));
        } else {
        
          console.error("Failed to fetch GetEmployeesTodaysAttendanceCount count data.");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  // const getTodayLeaveList = () => {
  //   const headers = apiHeaderJSON;

  //   axios
  //     .get(`${apiURL}DashboardRouter/GetEmployeesTodaysOnLeaveCount`, {
  //       params: {
  //         date: currentDateAndTime(),
  //         leave_date: currentDateAndTime()?.split(" ")[0],
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetEmployeesTodaysOnLeaveCount =>", data);
  //       if (response.data.success === true) {
  //         setDailyData((prevState) => ({
  //           ...prevState,
  //           today_leave_count: data?.data[0]?.on_leave_employee_count,
  //         }));
  //       } else {
  //       }
  //     });
  // };

//   const getTodayLeaveList = () => {
//     const headers = apiHeaderJSON;

//     axios
//       .get(`${apiURL}DashboardRouter/GetEmployeesTodaysOnLeaveCount`, {
//         params: {
//           date: currentDateAndTime(),
//           leave_date: currentDateAndTime()?.split(" ")[0], // Send just the date part
//         },
//         headers,
//       })
//       .then((response) => {
//         const data = response.data;
//         console.log("GetEmployeesTodaysOnLeaveCount =>", data, data.success);
//         if (data.success === true) {
//           console.log("data?.total_leave_count", data?.data);

//           setDailyData((prevState) => ({
//             ...prevState,
//             today_leave_count: data?.data?.total_leave_count || 0,
//           }));
//         } else {
//           console.error("Failed to fetch data", data.message);
//         }
//       })
//       .catch((error) => {
//         console.error("API Error:", error);
//       });
//   };

  // const getEmployeeJoinList = (monthYear) => {
  //   const selectMonthJoin = monthYear;
  //   const headers = apiHeaderJSON;

  //   // Save the selected month-year
  //   setSelectMonthJoin(selectMonthJoin);

  //   if (selectMonthJoin) {
  //     console.log("Fetching joining count for month-year: ", selectMonthJoin);
  //   }

  //   axios
  //     .get(`${apiURL}DashboardRouter/GetEmployeesJoinCountMonthWise`, {
  //       params: {
  //         request_month_year: selectMonthJoin,
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       console.log("GetEmployeesJoinCountMonthWise =>", response);
  //       const { data } = response; // Destructure API response

  //       if (data.success === true) {
  //         // Extract the data and pass to state
  //         console.log("Joining Data:", data.data.joining_count); // Log data for verification
  //         setJoiningData(data.data.joining_count); // Assuming data.data is an array
  //       } else {
  //         console.error(
  //           "Failed to fetch joining count. Message:",
  //           data.message
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching joining count:", error);
  //     });
  // };

  //   const getAttendanceCountByDepartment = async (monthYear) => {
  //     try {
  //       const headers = apiHeaderJSON;

  //       // Validate `monthYear` input
  //       if (!monthYear || !/^\d{2}-\d{4}$/.test(monthYear)) {
  //         console.error("Invalid monthYear format. Expected format: MM-YYYY");
  //         alert("Please provide a valid month and year in MM-YYYY format.");
  //         return;
  //       }

  //       // Make the API request
  //       const response = await axios.get(`${apiURL}DashboardRouter/GetAttendanceByDepartment`, {
  //         params: {
  //           request_month_year: monthYear,
  //         },
  //         headers,
  //       });

  //       const data = response.data;
  //       if (data.success === true) {
  //         console.log("GetAttendanceByDepartment =>", data);

  //         const departmentTitles=data?.data?.((dept)=>dept.department_title)
  //         console.log("departmentTitles",departmentTitles);
  //         const attendance=data?.data?.((dept)=>dept.attendance_percentage)
  //         console.log("attendance",attendance);
  //         setDepartmentAttendanceData(data?.data);
  // setChartOptionsDepartAttendance({
  //   labels:departmentTitles ||[],
  //   series:attendance || [],
  // })
  //       } else {
  //         console.error("Failed to fetch department-wise attendance data:", data.message);
  //         alert(data.message || "Failed to fetch data. Please try again.");
  //       }
  //     } catch (error) {
  //       console.error("API Error:", error.message);
  //       alert("An error occurred while fetching attendance data. Please check your connection and try again.");
  //     }
  //   };

 
  const getAttendanceCountByDepartment = (monthYear) => {
    const selectMonthAttendanceCount = monthYear;
    const headers = apiHeaderJSON;
    if (selectMonthAttendanceCount) {
      console.log(
        "fetching attendence count of department for month-year: ",
        selectMonthAttendanceCount
      );
      axios
        .get(`${apiURL}DashboardRouter/GetAttendanceByDepartment`, {
          params: {
            request_month_year: selectMonthAttendanceCount,
          },
          headers,
        })
        .then((response) => {
          const data = response.data;
          console.log("AttendanceCountByDepartment:", data);
          const attendenceCount = data.data;
          if (data.success === true) {
            setAttendanceData(attendenceCount);

            const departmentTitle = attendenceCount.map(
              (depta) => depta.department_title
            );
            console.log("departmentTitle: ", departmentTitle);
            const attendanceData = attendenceCount?.map(
              (depta) => depta.total_present_days
            );
            console.log("attendanceData: ", attendanceData);

            setCharAttendenceData({
              labels: departmentTitle || [],
              series: attendanceData || [],
            });
          } else {
            console.error(
              "Failed to fetch offer letter count. Message:",
              data.message
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching offer letter count:", error);
        });
    }
  };

  const getMonthlyAttendanceRates = (event) => {
    const selectMonthAttendanceRate = event;
    const headers = apiHeaderJSON;
    if (selectMonthAttendanceRate) {
      console.log(
        "Fetching monthly Attendence rate for month-year:",
        selectMonthAttendanceRate
      );
    }
    axios
      .get(`${apiURL}DashboardRouter/GetPresntAbsentRate`, {
        params: {
          request_month_year: selectMonthAttendanceRate,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log(
          "MonthlyAttendanceRates =>",
          data,
          parseFloat(data.data?.presentism_percentage) / 100,
          parseFloat(data.data?.absenteeism_percentage) / 100
        );

        if (data.success) {
          console.log("present_rate", setMonthlyAttendanceData);
          setMonthlyAttendanceData({
            present_rate: isNaN(data.data?.presentism_percentage)
              ? 0
              : parseFloat(data.data?.presentism_percentage),
            absence_rate: isNaN(data.data?.absenteeism_percentage)
              ? 0
              : parseFloat(data.data?.absenteeism_percentage),
          });
          console.log("present_rate", setMonthlyAttendanceData);
        } else {
          console.error("Failed to fetch attendance rates:", data.message);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

  const getMonthYearOptions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
        params: {
          current_date: currentDateAndTime(),
        },
        headers,
      })

      .then((response) => {
        const data = response.data;
        console.log("MonthYearOptions =>", data);

        if (data.success) {
          setMonthYearOptions(data.filterData);
          setSelectedMonthYear(Array.isArray(data.filterData) && data.filterData.length>0 && data.filterData[0]?.value);
          if(Array.isArray(data.filterData) && data.filterData.length>0){
            getMonthlyAttendanceRates(data.filterData[0]?.value);
            getDepartmentWiseOverTimeHours(data.filterData[0]?.value);
          }
        } else {
          console.error("Failed to fetch month-year options");
        }
      })
      .catch((error) => {
        console.error("Error fetching month-year options:", error);
      });
  };

 
 
  
  // const getDepartmentWiseEarnedSalaryData = (event) => {
  //   const selectMonthJoin = event;
  //   setSelectMonthJoin(selectMonthJoin);
  //   const headers = apiHeaderJSON;
  
  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: {
  //         request_month_year: selectMonthJoin,
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetDepartmentWiseEarnedSalary =>", data);
  
  //       if (response.data.success === true) {
  //         const departmentTitles = data?.data?.map(dept => dept.department_name) || [];
  //         const earnedSalaries = data?.data?.map(dept => dept.total_Earned_salary) || [];
  //         const totalDepartments = departmentTitles.length;
  
  //         console.log("departmentTitles", departmentTitles);
  //         console.log("earnedSalaries?.length", earnedSalaries.length);
  
  //         setDepartmentEarnedData(totalDepartments);
  
  //         const chunkSize = 5; // Number of elements in each chunk
  
  //         // Create chunks of labels and series
  //         const chunkedTitles = [];
  //         for (let i = 0; i < departmentTitles.length; i += chunkSize) {
  //           chunkedTitles.push(departmentTitles.slice(i, i + chunkSize));
  //         }
  
  //         const chunkedSeries = [];
  //         for (let i = 0; i < earnedSalaries.length; i += chunkSize) {
  //           chunkedSeries.push(earnedSalaries.slice(i, i + chunkSize));
  //         }
  
  //         // Set chart options
  //         setChartEarnedOptions({
  //           labels: chunkedTitles || [],
  //           series: chunkedSeries.map(chunk => ({
  //             name: "Department Wise Earned Salary",
  //             data: chunk,
  //           })) || [],
  //         });
  //       } else {
  //         console.error("Failed to fetch department-wise salary data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     });
  // };
  
  
  // const getDepartmentWiseEarnedSalaryData = (event) => {
  //   const selectedMonth = event;
  //   setSelectMonthJoin(selectedMonth);
    
  //   const headers = apiHeaderJSON;
  //   setLoading(true);
  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: { request_month_year: selectedMonth },
  //       headers,
  //     })
  //     .then((response) => {
  //       const { data } = response;
  //       console.log("GetDepartmentWiseEarnedSalary =>", data);
  
  //       // Ensure data exists and is in the expected structure
  //       if (data.success) {
  //         setLoading(false)
  //         const departmentTitles = data?.data?.map((dept) => dept.department_name) || [];
  //         const earnedSalaries = data?.data?.map((dept) => dept.total_Earned_salary) || [];
          
  //         console.log("departmentTitles:", departmentTitles);
  //         console.log("earnedSalaries:", earnedSalaries);
  
  //         const totalDepartments = departmentTitles.length;
  //         if (earnedSalaries.length === 0) {
  //           console.warn("No data available for the selected month.");
  //         }
  
  //         setDepartmentEarnedData(totalDepartments);
  
  //         // Chunk the data into smaller arrays for better chart handling
  //         const chunkSize = 5;
  
  //         const chunkedTitles = chunkData(departmentTitles, chunkSize);
  //         const chunkedSalaries = chunkData(earnedSalaries, chunkSize);
  
  //         // Set the chart options
  //         setChartEarnedOptions({
  //           labels: chunkedTitles || [],
  //           series: chunkedSalaries.map((chunk) => ({
  //             name: "Department Wise Earned Salary",
  //             data: chunk,
  //           })) || [],
  //         });
  //       } else {
  //         console.error("Failed to fetch department-wise salary data:", data.message || "Unknown error");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     });
  // };
  
  // Utility function to chunk an array
  // const chunkData = (data, chunkSize) => {
  //   const chunked = [];
  //   for (let i = 0; i < data.length; i += chunkSize) {
  //     chunked.push(data && data?.slice(i, i + chunkSize));
  //   }
  //   return chunked;
  // }; 

  // Utility function to chunk an array
const chunkData = (data, chunkSize) => {
  if (!Array.isArray(data)) {
    console.warn("Invalid input: data is not an array");
    return []; 
  }

  const chunked = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunked.push(data.slice(i, i + chunkSize));
  }
  return chunked;
};

  
  


   
    const getDepartmentWiseOverTimeHours = (event) => {
      const selectMonthOver = event;
      setSelectMonthOver(selectMonthOver);
    
      const headers = apiHeaderJSON;
      setLoading2(true);
    
      axios
        .get(`${apiURL}DashboardRouter/GetDepartmentWiseOverTimeHours`, {
          params: { request_month_year: selectMonthOver },
          headers,
        })
        .then((response) => {
          const data = response.data;
          console.log("GetDepartmentWiseOverTimeHours =>", data);
    
          if (data.success === true && Array.isArray(data.data)) {
            const departmentTitles = data.data.map((dept) => dept.department_name || "Unknown");
            const overTimeHours = data.data.map((dept) => dept.total_overtime_hours || 0);
    
            console.log("departmentTitles", departmentTitles);
            console.log("overTimeHours", overTimeHours);
    
            setDepartmentOverTimeData(departmentTitles.length);
    
            const chunkSize = 5; // Number of elements in each chunk
            const chunkedTitles = [];
            const chunkedSeries = [];
    
            if (departmentTitles.length > 0) {
              for (let i = 0; i < departmentTitles.length; i += chunkSize) {
                chunkedTitles.push(departmentTitles.slice(i, i + chunkSize));
              }
            }
    
            if (overTimeHours.length > 0) { 
              for (let i = 0; i < overTimeHours.length; i += chunkSize) {
                chunkedSeries.push(overTimeHours.slice(i, i + chunkSize));
              }
            } else {
              chunkedSeries.push([0]); // Ensure this is an array for consistency
            }
    
            
    
            let transformedSeriesData = chunkedSeries.map((chunk) => ({
              name: "Department Wise Over Time Hours",
              data: chunk,
            }));
            transformedSeriesData=transformedSeriesData?.length>0? transformedSeriesData:{ name: 'No Data', data: [0] };
            console.log("chunkedTitles", chunkedTitles);
            console.log("transformedSeriesData", transformedSeriesData);
            setChartOverTimeOptions({
              labels: chunkedTitles ,
              series: transformedSeriesData ,
            });
          } else {
            console.error(
              "Failed to fetch department-wise OverTimeHours data or data is not in expected format:",
              data.message || "Unknown error"
            );
            setChartOverTimeOptions({
              labels: ["No data"],
              series: [],
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching department-wise OverTimeHours data:", error);
        })
        .finally(() => {
          setLoading2(false); // Ensure loading state is updated
        });
    };
    
    
    

    const getLocationWiseOverTimeHours = (event) => {
      const selectMonthLocOver = event;
      setSelectMonthLocOver(selectMonthLocOver);
      const headers = apiHeaderJSON;
  
      axios
        .get(`${apiURL}DashboardRouter/GetLocationWiseOverTimeHours`, {
          params: {
            request_month_year:selectMonthLocOver ,
          },
          headers,
        })
        .then((response) => {
          const locOver = response.data;
          console.log("GetLocationWiseOverTimeHours =>", locOver);
          if (response.data.success === true) {
            const chunkSize = 5; // Number of elements in each chunk
            const chunkedTitles = [];
            const chunkedSeries = [];
            const LocationTitles = locOver?.data?.map(
              (dept) => dept.location_name
            );
            setLocationOverTimeData(LocationTitles.length);
            if (LocationTitles.length > 0) {
              for (let i = 0; i < LocationTitles.length; i += chunkSize) {
                chunkedTitles.push(LocationTitles.slice(i, i + chunkSize));
              }
            }
            const overTimeHours = locOver?.data?.map((dept) => dept.total_overtime_hours);

            if (overTimeHours.length > 0) { 
              for (let i = 0; i < overTimeHours.length; i += chunkSize) {
                chunkedSeries.push(overTimeHours.slice(i, i + chunkSize));
              }
            } else {
              chunkedSeries.push([0]); // Ensure this is an array for consistency
            }
            let transformedSeriesData = chunkedSeries.map((chunk) => ({
              name: "Location Wise Over Time Hours",
              data: chunk,
            }));
            transformedSeriesData=transformedSeriesData?.length>0? transformedSeriesData:[{ name: 'No Data', data: [0] }];
            console.log("chunkedTitles location", chunkedTitles);
            console.log("transformedSeriesData location", transformedSeriesData);
            setChartLocOverTimeOptions({
              labels: chunkedTitles, 
              series: transformedSeriesData,
            } );
          } else {
            console.error("Failed to fetch department-wise OverTimeHours data");
          }
        })
        .catch((error) => {
          console.error("Error fetching department-wise OverTimeHours data:", error);
        });
    };

  useEffect(()=>{
    console.log(chartOverTimeOptions?.labels,chartOverTimeOptions?.series)
    console.log(chartLocOverTimeOptions?.labels,chartLocOverTimeOptions?.series)
  },[chartLocOverTimeOptions]);

  const handleSelectChange = (name, selectedOption) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    const selectedValue = selectedOption ? selectedOption.value : "";

    if (name === "month_year") {
      if (selectedValue !== selectedMonthYear) {
        setSelectedMonthYear(selectedValue);
        setCurrentIndex({
          departmentWiseCountIndex:0,
          departmentWiseEarnedGrossIndex:0,
          departmentWiseNetGrossIndex:0,
          departmentWiseOverTimeHoursIndex:0,
          locationWiseOverTimeHoursIndex:0,
        })
        console.log("Month-Year changed to:", selectedValue);
       
        getAttendanceCountByDepartment(selectedValue);
        getMonthlyAttendanceRates(selectedValue);
        getAttendanceCountByDepartment(selectedValue);
        getDepartmentWiseOverTimeHours(selectedValue);
        // getDepartmentWiseGrossSalaryMonthWise(selectedValue);
        // getLocationWiseGrossSalaryMonthWise(selectedValue);
        getLocationWiseOverTimeHours(selectedValue)
        setSelectedMonthYear(selectedOption?.value || null);
      }
    } else if (name === "offer_status") {
      if (selectedValue !== selectedOfferStatus) {
        setSelectedOfferStatus(selectedValue);
        console.log("Offer Status changed to:", selectedValue);
       
      }
    }
  };

  useEffect(() => {
    getList();
    getPresentEmployeeList();
    // getTodayLeaveList();
    // getDepartmentWiseCountList();
    // getLocationWiseCountList();
    // getLeaveTypeWiseCountList();
    getMonthYearOptions();
    // getCurrentMonthYear();
    if (inputRef.current) {
      flatpickr(inputRef.current, {
        dateFormat: "d M, Y",
        defaultDate: "today",
        inline: true,
      });
    }
    const sourceDiv = sourceDivRef.current;

    if (sourceDiv) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          // Update the target div height whenever the source div resizes
          setTargetDivHeight(`${entry.contentRect.height}px`);
        }
      });

      // Observe the source div for resizing
      resizeObserver.observe(sourceDiv);

      return () => {
        // Clean up observer on component unmount
        resizeObserver.disconnect();
      };
    }
  }, []);
  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
       setVisibleDepartments(showMore ? 6 : chartOptions?.labels?.length);
  };
  const renderLabels = (labels) => labels?.length > 0 ? labels : ['No Data'];
  const renderSeries = (series) => series?.length > 0 ? series : [0];

   const chartOptionsLine = {
    chart: {
      type: "line",
    },
    series: [
      {
        name: "Joins",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    },
    colors: ["#687cfe"],
  };

  const [currentIndex, setCurrentIndex] = useState({
    departmentWiseCountIndex:0,
    departmentWiseEarnedGrossIndex:0,
    departmentWiseNetGrossIndex:0,
    departmentWiseOverTimeHoursIndex:0,
    locationWiseOverTimeHoursIndex:0,
  });
  const [animationDirection, setAnimationDirection] = useState({
    departmentWiseCountAnimation:"",
    departmentWiseEarnedGrossAnimation:"",
    departmentWiseNetGrossAnimation:"",
    departmentWiseOverTimeHoursAnimation:"",
    locationWiseOverTimeHoursAnimation:"",

  });
  const [currentIndex1,setCurrentIndex1]= useState(0);
  const [currentIndex2,setCurrentIndex2]= useState(0);
  const [currentIndex3,setCurrentIndex3]= useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
   // For controlling the slide direction
  const [animating, setAnimating] = useState(false);

const handlePrev = (type) => {
if (animating) return;
  if (type === "1") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseCountAnimation:"slide-right",
    });
  } else if (type === "2") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseEarnedGrossAnimation:"slide-right",
    });
  } else if (type === "3") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseNetGrossAnimation:"slide-right",
    });
  } 
  else if (type === "4") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseOverTimeHoursAnimation:"slide-right",
    });
  }
  else if (type === "5") {
    setAnimationDirection({
      ...animationDirection,
      locationWiseOverTimeHoursAnimation:"slide-right",
    });
  }
 setAnimating(true);
 
  setTimeout(() => {
    if(type==="1"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseCountIndex:(currentIndex?.departmentWiseCountIndex === 0 ? chartOptions.series.length - 1 : currentIndex?.departmentWiseCountIndex - 1),
      });
    }else if(type==="2"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseEarnedGrossIndex:(currentIndex?.departmentWiseEarnedGrossIndex === 0 ? chartEarnedOptions.series.length - 1 : currentIndex?.departmentWiseEarnedGrossIndex - 1),
      });
    }else if(type==="3"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseNetGrossIndex:(currentIndex?.departmentWiseNetGrossIndex === 0 ? chartNetOptions.series.length - 1 : currentIndex?.departmentWiseNetGrossIndex - 1),
      });
    }
    else if(type==="4"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseOverTimeHoursIndex:(currentIndex?.departmentWiseOverTimeHoursIndex === 0 ? chartOverTimeOptions?.series.length - 1 : currentIndex?.departmentWiseOverTimeHoursIndex - 1),
      });
    }
    else if(type==="5"){
      setCurrentIndex({
        ...currentIndex,
        locationWiseOverTimeHoursIndex:(currentIndex?.locationWiseOverTimeHoursIndex === 0 ? chartLocOverTimeOptions?.series.length - 1 : currentIndex?.locationWiseOverTimeHoursIndex - 1),
      });
    }
   
    setAnimationDirection({
      departmentWiseCountAnimation:"",
      departmentWiseEarnedGrossAnimation:"",
      departmentWiseNetGrossAnimation:"",
      departmentWiseOverTimeHoursAnimation:"",
      locationWiseOverTimeHoursAnimation:"",
    });
    setAnimating(false);
  }, 500); 
}
const handleNext = (type) => {
  if (animating) return;
  if (type === "1") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseCountAnimation:"slide-left",
    });
  } else if (type === "2") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseEarnedGrossAnimation:"slide-left",
    });
  } else if (type === "3") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseNetGrossAnimation:"slide-left",
    });
  }
   else if (type === "4") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseOverTimeHoursAnimation:"slide-left",
    });
  }
   else if (type === "5") {
    setAnimationDirection({
      ...animationDirection,
      locationWiseOverTimeHoursAnimation:"slide-left",
    });
  }
  setAnimating(true);
  setTimeout(() => {
    if(type==="1"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseCountIndex:(currentIndex?.departmentWiseCountIndex === chartOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseCountIndex + 1),
      });
    }
    else if(type==="2"){
    setCurrentIndex({
        ...currentIndex,
        departmentWiseEarnedGrossIndex:(currentIndex?.departmentWiseEarnedGrossIndex === chartEarnedOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseEarnedGrossIndex + 1),
      });
  
    } else if(type==="3"){
     setCurrentIndex({
        ...currentIndex,
        departmentWiseNetGrossIndex:(currentIndex?.departmentWiseNetGrossIndex === chartNetOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseNetGrossIndex + 1),
      });
      
    }else if(type==="4"){
     setCurrentIndex({
        ...currentIndex,
        departmentWiseOverTimeHoursIndex:(currentIndex?.departmentWiseOverTimeHoursIndex === chartOverTimeOptions?.series.length - 1 ? 0 : currentIndex?.departmentWiseOverTimeHoursIndex + 1),
      });
      setCurrentIndex1((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1));
    }else if(type==="5"){
      setCurrentIndex({
         ...currentIndex,
         locationWiseOverTimeHoursIndex:(currentIndex?.locationWiseOverTimeHoursIndex === chartLocOverTimeOptions.series.length - 1 ? 0 : currentIndex?.locationWiseOverTimeHoursIndex + 1),
       });
       setCurrentIndex1((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1));
     }
    
    // setCurrentIndex1((prev) => (prev === chartEarnedOptions.series.length - 1 ? 0 : prev + 1));
    // setCurrentIndex2((prev) => (prev === chartNetOptions.series.length - 1 ? 0: prev + 1));
    // setCurrentIndex3((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0: prev + 1));
     setAnimationDirection({
      departmentWiseCountAnimation:"",
      departmentWiseEarnedGrossAnimation:"",
      departmentWiseNetGrossAnimation:"",
      departmentWiseOverTimeHoursAnimation:"",
      locationWiseOverTimeHoursAnimation:"",
     });
    setAnimating(false);

  }, 500); // Match the CSS transition duration
};
  const navigate = useNavigate();
  
    const handleNavigation = () => {
      navigate('/CandidateDetailsList');
    };
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  // const presentRate = parseFloat(attendanceData.present_rate)
  return (
   <div className="">
      <div className="card pt-4 ps-4">
        <div className="row">
          <div className="col-xl-3">
            <div className="card card-animate">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-success-subtle rounded-2 fs-2">
                      <i className="bx bx-calendar-check text-primary" />
                    </span>
                  </div>
                  <div className="flex-grow-1 ms-3" onClick={handleNavigation}>
                    <p className="text-uppercase fw-medium text-muted mb-3">
                    Employees
                    </p>
                    <div className="d-flex align-items-center mb-3">
                      <h4 className="flex-grow-1 mb-0">
                        <span className="counter-value" data-target={0}>
                        {dailyData?.employee_count || 0}
                        </span>
                      </h4>
                      {/* <span className="badge bg-success-subtle text-success fs-12">
                        <i className="ri-arrow-up-s-line fs-13 align-middle me-1" />
                        3.58 %
                      </span> */}
                    </div>
                    <p className="text-muted mb-0">Active Employees</p>
                  </div>
                </div>
              </div>
              {/* end card body */}
            </div>
          </div>
          <div className="col-xl-3">
            <div className="card card-animate">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-success-subtle rounded-2 fs-2">
                      <i className="bx bx-calendar-check text-primary" />
                    </span>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-medium text-muted mb-3">
                      Present
                    </p>
                    <div className="d-flex align-items-center mb-3">
                      <h4 className="flex-grow-1 mb-0">
                        <span className="counter-value" data-target={0}>
                          {dailyData?.presentee_count || 0}
                        </span>
                      </h4>
                      {/* <span className="badge bg-success-subtle text-success fs-12">
                        <i className="ri-arrow-up-s-line fs-13 align-middle me-1" />
                        3.58 %
                      </span> */}
                    </div>
                    <p className="text-muted mb-0">Today's Attendance</p>
                  </div>
                </div>
              </div>
              {/* end card body */}
            </div>
          </div>
          {/* end col */}
          <div className="col-xl-3">
            <div className="card card-animate">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-secondary-subtle text-secondary rounded-2 fs-2">
                      <i className="bx bx-calendar-x text-secondary" />
                    </span>
                  </div>
                  <div className="flex-grow-1 overflow-hidden ms-3">
                    <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                      Absentee
                    </p>
                    <div className="d-flex align-items-center mb-3">
                      <h4 className="flex-grow-1 mb-0">
                        <span className="counter-value" data-target={0}>
                          {dailyData?.employee_count -
                            dailyData?.presentee_count || 0}
                        </span>
                      </h4>
                      {/* <span className="badge bg-danger-subtle text-danger fs-12">
                        <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                        5.35 %
                      </span> */}
                    </div>
                    <p className="text-muted text-truncate mb-0">
                    Today's Absenteeism
                    </p>
                  </div>
                </div>
              </div>
              {/* end card body */}
            </div>
          </div>
        </div>  
      </div>  
      <div className="dropdown-divider" />        
      <div className="card p-2">        
        <div className="row col-md-12">
          <div className="col-xl-6 ">
            <div className="row">
              <div className="col-md-12">
                <div className="card-body">
                  <label htmlFor="month_year" className="form-label">
                    Month Year:
                  </label>
                  <Select
                    id="month_year"
                    name="month_year"
                    value={selectedMonthYear? monthYearOptions.find((option) => option.value === selectedMonthYear): null}
                    onChange={(selectedOption) =>
                      handleSelectChange("month_year", selectedOption)
                    }
                    options={monthYearOptions}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <h4 className="text-center mt-3">Monthly Attendance Dashboard</h4>
                <div className=" d-flex justify-content-around gap-3">
                  {/* Presentism Rate Gauge */}
                  <div style={{ textAlign: "center" }}>
                    <GaugeChart
                      id="presentism-rate-chart"
                      nrOfLevels={20}
                      percent={
                        isNaN(monthlyAttendanceData.present_rate / 100)
                          ? 0
                          : monthlyAttendanceData.present_rate / 100
                      }
                      colors={["#6FCF97", "#ECEFF4"]}
                      arcWidth={0.3}
                      textColor="#000"
                      style={{ width: "200px" }}
                    />
                    <h6>Presenteeism Rate</h6>
                  </div>
                  {/* Absenteeism Rate Gauge */}
                  <div style={{ textAlign: "center" }}>
                    <GaugeChart
                      id="absenteeism-rate-chart"
                      nrOfLevels={20}
                      percent={
                        isNaN(monthlyAttendanceData.absence_rate / 100)
                          ? 0
                          : monthlyAttendanceData.absence_rate / 100
                      }
                      colors={["#FF5F6D", "#ECEFF4"]}
                      arcWidth={0.3}
                      textColor="#000"
                      style={{ width: "200px" }}
                    />
                    <h6>Absenteeism Rate</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 ">
            <div ref={sourceDivRef} className="card">
              <div>
                <div className="text-center mt-3">
                  <h5>Department Wise Over Time Hours</h5>
                  {/* { chartOverTimeOptions?.labels.length>0 && chartOverTimeOptions?.labels[0]} */}
                </div>
              </div>
              <div className="overflow-hidden">
                {loading2 ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "65vh" }}>
                    <div className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {departmentOverTimeData > 5 && (
                      <button onClick={()=>{handlePrev("4")}}className="nav-btn prev-btn">Prev</button>
                    )}

                    <div className={`chart-wrapper ${animationDirection.departmentWiseOverTimeHoursAnimation}`}>
                      <ApexCharts
                        options={{
                          chart: {
                            type: 'bar',
                            height: '50vh',
                            toolbar: { show: true },
                          },
                          plotOptions: {
                            bar: {
                              horizontal: true,
                              columnWidth: '55%',
                              endingShape: 'rounded',
                            },
                          },
                          colors: ['#FFD700'], 
                          dataLabels: {
                            enabled: true, // Enable data labels
                            style: {
                              fontSize: '12px',
                              colors: ['#646300'], 
                            },
                            offsetX: 10, 
                            formatter: function (val) {
                              return `${val}`; // Customize the format of the label (e.g., add units if needed)
                            },
                          },
                          stroke: {
                            show: true,
                            width: 2,
                            colors: ['transparent'],
                          },
                          xaxis: {
                            categories: Array.isArray(chartOverTimeOptions?.labels) && chartOverTimeOptions?.labels.length>0 
                              ? chartOverTimeOptions.labels[currentIndex?.departmentWiseOverTimeHoursIndex] : ['No Data']
                            ,
                            title: {
                              text: `Hours ${departmentOverTimeData > 5 ? `(${currentIndex?.departmentWiseOverTimeHoursIndex+1}-${chartOverTimeOptions?.labels.length})`:''}`,
                              // text: `Departments-${currentIndex?.departmentWiseOverTimeHoursIndex+1}`,
                              style: { fontSize: '12px', fontWeight: 'bold' },
                            },
                          },
                          yaxis: {
                            title: {
                              // text: 'Count',
                              text: `Departments`,
                              style: { fontSize: '12px', fontWeight: 'bold' },
                            },
                          },
                          fill: { opacity: 1 },
                          legend: {
                            position: 'top',
                            horizontalAlign: 'center',
                          },
                          tooltip: {
                            y: {
                              formatter: function (value) {
                                return `${value}`;
                              },
                            },
                          },
                        }}
                        series={[
                          Array.isArray(chartOverTimeOptions?.series) && chartOverTimeOptions?.series[currentIndex?.departmentWiseOverTimeHoursIndex]
                            ? chartOverTimeOptions?.series[currentIndex?.departmentWiseOverTimeHoursIndex]
                            : { name: 'No Data', data: [0] },
                        ]}
                        type="bar"
                      />
                    </div>

                    {departmentOverTimeData > 5 && (
                      <button onClick={()=> {handleNext("4")}} className="nav-btn next-btn">Next</button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div className="card p-2">        
        <div className="row col-md-12">
          <div className="col-xl-6 ">
            <div ref={sourceDivRef} className="">
              <div>
                <div className="text-center mt-3">
                  <h5>Location Wise Over Time Hours</h5>
                  {/* {chartLocOverTimeOptions.labels[currentIndex?.locationWiseOverTimeHoursIndex] } */}
                </div>
              </div>
              <div className="overflow-hidden">
                {loading2 ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "65vh" }}>
                    <div className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {locationOverTimeData > 5 && (
                      <button onClick={()=>{handlePrev("5")}}className="nav-btn prev-btn">Prev</button>
                    )}

                    <div className={`chart-wrapper ${animationDirection.locationWiseOverTimeHoursAnimation}`}>
                      <ApexCharts
                        options={{
                          chart: {
                            type: 'bar',
                            height: '50vh',
                            toolbar: { show: true },
                          },
                          plotOptions: {
                            bar: {
                              horizontal: true,
                              columnWidth: '55%',
                              endingShape: 'rounded',
                            },
                          },
                          colors: ['#059d12'], 
                          dataLabels: {
                            enabled: true, // Enable data labels
                            style: {
                              fontSize: '12px',
                              colors: ['#00410b'], 
                            },
                            offsetX: 10, 
                            formatter: function (val) {
                              return `${val}`; // Customize the format of the label (e.g., add units if needed)
                            },
                          },
                          stroke: {
                            show: true,
                            width: 2,
                            colors: ['transparent'],
                          },
                          xaxis: {
                            categories: Array.isArray(chartLocOverTimeOptions?.labels) && chartLocOverTimeOptions?.labels.length>0
                              ? chartLocOverTimeOptions.labels[currentIndex?.locationWiseOverTimeHoursIndex] : ['No Data']
                            ,
                            title: {
                              text: `Hours ${locationOverTimeData > 5 ? `(${currentIndex?.locationWiseOverTimeHoursIndex+1}-${chartLocOverTimeOptions?.labels.length})`:''}`,
                              // text: `Departments-${currentIndex?.departmentWiseOverTimeHoursIndex+1}`,
                              style: { fontSize: '12px', fontWeight: 'bold' },
                            },
                          },
                          yaxis: {
                            title: {
                              // text: 'Count',
                              text: `Departments`,
                              style: { fontSize: '12px', fontWeight: 'bold' },
                            },
                          },
                          fill: { opacity: 1 },
                          legend: {
                            position: 'top',
                            horizontalAlign: 'center',
                          },
                          tooltip: {
                            y: {
                              formatter: function (value) {
                                return `${value}`;
                              },
                            },
                          },
                        }}
                        series={[
                          Array.isArray(chartLocOverTimeOptions?.series) && chartLocOverTimeOptions?.series[currentIndex?.locationWiseOverTimeHoursIndex]
                            ? chartLocOverTimeOptions?.series[currentIndex?.locationWiseOverTimeHoursIndex]
                            : { name: 'No Data', data: [0] },
                        ]}
                        type="bar"
                      />
                    </div>

                    {locationOverTimeData > 5 && (
                      <button onClick={()=> {handleNext("5")}} className="nav-btn next-btn">Next</button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AttendanceDashboard;
